var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_2236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_2236",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.575 15.575V0.425049H0.425V15.575H15.575Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.85
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_2236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.40624 1.71878V6.71876C2.40624 7.40913 2.9659 7.96876 3.65624 7.96876H5.21873V10.4688L7.71873 7.96876H14.2812C14.9715 7.96876 15.5312 7.40913 15.5312 6.71876V1.71878C15.5312 1.0284 14.9715 0.46878 14.2812 0.46878H3.65624C2.9659 0.46878 2.40624 1.0284 2.40624 1.71878Z",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40624 5.53128H1.71875C1.0284 5.53128 0.46875 6.0909 0.46875 6.78128V11.7813C0.46875 12.4716 1.0284 13.0313 1.71875 13.0313H2.65624V15.5312L5.15624 13.0313H11.7187C12.4091 13.0313 12.9687 12.4716 12.9687 11.7813V7.96877",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.54883 5.9375L7.83961 2.54845C7.86598 2.48395 7.95726 2.48382 7.98376 2.54829L9.26282 5.9375",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95117 5.09351H8.86654",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7682 2.50001H4.37498V5.9375",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37498 4.18628H5.65754",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.619 4.8239L13.7187 5.92358",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7051 4.21876C13.7051 5.168 12.9356 5.9375 11.9863 5.9375C11.0371 5.9375 10.2676 5.168 10.2676 4.21876C10.2676 3.26951 11.0371 2.50001 11.9863 2.50001C12.9356 2.50001 13.7051 3.26951 13.7051 4.21876Z",
    stroke: "#767676",
    strokeWidth: 0.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_2236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.4c205b209770c7640d31ef884683b0bd.svg";
export { ForwardRef as ReactComponent };